import {
  Target,
  FileCheck2,
  ShieldCheck,
  UserCheck,
  Lock,
  Fingerprint,
  Workflow,
  TrendingUp,
  ClipboardCheck,
  Network,
} from 'lucide-react';

const QUANTITY = 10;

const cards: {
  label: string;
  desc: string;
  icon: typeof Target;
  color: string;
}[] = [
  { label: 'Intent',     desc: 'Every action starts from a stated goal.',   icon: Target,         color: '7,78,220'   },
  { label: 'Evidence',   desc: 'Work is backed by verifiable records.',     icon: FileCheck2,      color: '255,140,0'  },
  { label: 'Governance', desc: 'Rules and limits stay always in force.',    icon: ShieldCheck,     color: '74,172,0'   },
  { label: 'Oversight',  desc: 'People review and approve outcomes.',       icon: UserCheck,       color: '237,2,22'   },
  { label: 'Safety',     desc: 'Guardrails keep AI work within bounds.',    icon: Lock,            color: '7,78,220'   },
  { label: 'Audit',      desc: 'Any step can be traced end to end.',        icon: ClipboardCheck,  color: '255,140,0'  },
  { label: 'Trust',      desc: 'Identity and integrity are provable.',      icon: Fingerprint,     color: '74,172,0'   },
  { label: 'Work',       desc: 'AI and human effort become one flow.',      icon: Workflow,        color: '237,2,22'   },
  { label: 'Outcomes',   desc: 'Effort connects to accountable results.',   icon: TrendingUp,      color: '7,78,220'   },
  { label: 'Connect',    desc: 'Governed links reach the wider system.',    icon: Network,         color: '255,140,0'  },
];

/**
 * Ten cards arranged in a 3D Y-axis ring that rotates continuously.
 * Each card is coloured in the TICCA teal-to-blue spectrum.
 */
export function CardCarousel3D() {
  return (
    <div className="ticca-carousel-wrap">
      <div
        className="ticca-carousel-inner"
        style={{ '--quantity': QUANTITY } as React.CSSProperties}
      >
        {cards.map(({ label, desc, icon: Icon, color }, i) => (
          <div
            key={label}
            className="ticca-carousel-card"
            style={
              {
                '--index':     i,
                '--quantity':  QUANTITY,
                '--colorCard': color,
              } as React.CSSProperties
            }
          >
            <div className="img">
              <Icon size={26} />
              <span>{label}</span>
              <p>{desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
